import React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { GuestPicker } from "./GuestPicker";
import { Button } from "../../button/Button";

interface IProps {
  namespace: string;
  groupName?: string;
  onComplete(): void;
  styles?: any;
}

// バリデーションやエラー表示をやりやすくするために
// react hook formに依存している
export const ScrollableGuestPicker: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { namespace, groupName, styles, onComplete } = props;

  const { t } = useTranslation(["button"]);

  const onPickerComplete = (e): void => {
    e.preventDefault();
    onComplete();
  };

  return (
    <div css={[blockStyle, styles]}>
      <div css={pickerBlockStyle}>
        <GuestPicker namespace={namespace} groupName={groupName} />
      </div>
      <div css={footerStyle}>
        <div css={buttonBlockStyle}>
          <Button type="button" onClick={onPickerComplete}>
            {t("common.set")}
          </Button>
        </div>
      </div>
    </div>
  );
};

const blockStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: auto;
  background-color: white;
  border-top: 1px solid ${borderColor.secondaryLightColor};
`;
const pickerBlockStyle = css`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding: ${space.atom};
`;
const footerStyle = css`
  padding: ${space.atom};
  box-sizing: border-box;
  min-height: 4.5rem;
  border-top: 1px solid ${borderColor.primaryLightColor};
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.1);
`;
const buttonBlockStyle = css`
  padding: ${space.atom};
`;
